import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureMembershipListModule } from '../lib/shared-feature-membership-list.module'
import { MembershipListDocsComponent } from './membership-list-docs/membership-list-docs.component'
import { MembershipListExampleComponent } from './membership-list-docs/membership-list-example.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureMembershipListModule,
  ],
  declarations: [
    MembershipListDocsComponent,
    MembershipListExampleComponent
  ],
  exports: [
    MembershipListDocsComponent
  ]
})
export class SharedFeatureMembershipListDocsModule {}
